import { call, put, select, takeLatest } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { selectExtraRoutesAuthData, selectAuthData } from '@/containers/Login/AuthSelectors'
import {
  fetchStart,
  fetchSuccess,
  fetchError,
  deleteStart,
  deleteFinished,
  setPage,
} from './ClientCallbacksSlice'
import { showSnackbar, SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import { removeItem } from './ClientCallbacksSlice'

export const clientCallbacksActions = {
  FETCH: 'CLIENT_CALLBACKS/FETCH',
  DELETE: 'CLIENT_CALLBACKS/DELETE',
}

function* fetchCallbacks(action) {
  try {
    const { view, country, search, page } = action
    yield put(fetchStart())
    const { scheduleCallbackPaginatedListUrl } = yield select(selectExtraRoutesAuthData)
    if (!scheduleCallbackPaginatedListUrl) throw new Error('Missing URL')
    const { country: authCountry } = yield select(selectAuthData)

    const query = buildQuery({
      view,
      country: country || authCountry?.toLowerCase(),
      search,
      page,
    })

    const data = yield call(callApi, {
      endpoint: `${scheduleCallbackPaginatedListUrl}?${query}`,
      method: 'GET',
      showErrorSnackbar: false,
    })
    yield put(fetchSuccess(mapResponse(data)))
  } catch (error) {
    yield put(fetchError(error.message || 'Error'))
  }
}

function* deleteCallback(action) {
  const { id, enqueue } = action
  try {
    const routes = yield select(selectExtraRoutesAuthData)
    const { scheduleCallbackDeleteUrl } = routes || {}
    if (!scheduleCallbackDeleteUrl) throw new Error('Missing delete URL')
    yield put(deleteStart(id))
    const endpoint = scheduleCallbackDeleteUrl.includes('*')
      ? scheduleCallbackDeleteUrl.replace('*', id)
      : `${scheduleCallbackDeleteUrl}/${id}`
    const result = yield call(callApi, { endpoint, method: 'DELETE', showErrorSnackbar: true, enqueue })
    yield put(deleteFinished())
    if (enqueue) {
      yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.SUCCESS, message: result?.message || 'Deleted' })
    }
  // Optimistic remove without refetch
  yield put(removeItem(id))
  } catch (error) {
    yield put(deleteFinished())
    if (enqueue) {
      yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message: error.message || 'Delete error' })
    }
  }
}

const mapResponse = raw => {
  const items = Array.isArray(raw?.data) ? raw.data : []
  const meta = raw?.meta || {}
  return {
    items,
    pagination: {
      currentPage: meta.current_page || 1,
      lastPage: meta.last_page || 1,
      perPage: meta.per_page || items.length,
      total: meta.total || items.length,
    },
  }
}

const buildQuery = ({ view, country, search, page }) => {
  const queryParams = new URLSearchParams()
  if (view === 'deleted') {
    queryParams.append('status', 'deleted')
  } else {
    queryParams.append('status', 'scheduled')
    queryParams.append('time_filter', view === 'last' ? 'last' : 'upcoming')
  }
  if (country) queryParams.append('country', country)
  if (search) queryParams.append('search', search)
  if (page) queryParams.append('page', String(page))
  return queryParams.toString()
}

export default function* clientCallbacksSagas() {
  yield takeLatest(clientCallbacksActions.FETCH, fetchCallbacks)
  yield takeLatest(clientCallbacksActions.DELETE, deleteCallback)
}
